(() => {
  if (window.cereblueNavigationReady) return;
  window.cereblueNavigationReady = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.menu-drawer a[data-cb-nav]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    const destination = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!destination) return;
    const drawer = link.closest('header-drawer');
    drawer?.closeMenuDrawer?.(event, destination);
    drawer?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    destination.focus({ preventScroll: true });
  });
})();
